import React from 'react'
import _ from 'underscore'
import { ChevronDown, RefreshCw } from 'lucide-react'
import { Button } from '@/components/ui/button'
import { Label } from '@/components/ui/label'
import store from '../../state/store'
import { DropdownMenu } from '../dropdown_menu'
import DateRangePicker from '../date_range_picker'

const TERMINAL_COLUMNS = ['closed', 'handed_over']

class PipelineFilters extends React.Component {
  onManagerChange = (value) => {
    store.emit('pipeline:filter:manager', value)
  }

  onRefresh = (e) => {
    e.preventDefault()
    store.emit('pipeline:index')
  }

  onRangeChange = (from, to) => {
    store.emit('pipeline:filter:terminal_range', { from, to })
  }

  render() {
    const p = this.props.pipeline
    const all_option = { value: 'all', name: 'All managers' }
    const items = [all_option].concat(p.manager_options || [])
    const selected = _.first(_.select(items, (m) => `${m.value}` === `${p.manager_id}`)) || all_option

    const onTerminalTab = TERMINAL_COLUMNS.includes(p.current_tab)

    return (
      <div className="flex flex-wrap items-center gap-x-4 gap-y-2">
        <div className="flex items-center gap-2">
          <Label className="text-muted-foreground">Manager</Label>
          <DropdownMenu
            searchable
            buttonClassName="btn btn-secondary btn-sm"
            items={items}
            onItemClick={this.onManagerChange}
          >
            {selected.name}{selected.count != null ? ` (${selected.count})` : ''} <ChevronDown className="size-3.5" />
          </DropdownMenu>
        </div>

        {onTerminalTab ? (
          <div className="flex items-center gap-2">
            <Label className="text-muted-foreground">Date range</Label>
            <DateRangePicker
              start_date={p.terminal_from}
              end_date={p.terminal_to}
              onChange={this.onRangeChange}
              align="left"
            />
          </div>
        ) : null}

        <Button
          type="button"
          variant="ghost"
          size="icon-sm"
          onClick={this.onRefresh}
          title="Refresh"
        >
          <RefreshCw className="size-4" />
        </Button>
      </div>
    )
  }
}

export default PipelineFilters
